import { ActivatedRouteSnapshot } from '@angular/router';

export class DefaultResolver {
  /**
   * Find the first param identified by its name in the route hierarchy
   * @param {ActivatedRouteSnapshot} route
   * @param {string}                 paramName
   */
  getRouteParam(route: ActivatedRouteSnapshot, paramName: string) {
    let currentRoute = route;
    while (currentRoute !== null) {
      let param = currentRoute.params[paramName];
      if (param !== null) {
        return param;
      }
      currentRoute = currentRoute.parent;
    }
    throw new Error('Impossible to find route parameter named ' + paramName);
  }

  /**
   * Find the first route data identified by its name in the route hierarchy
   * @param {ActivatedRouteSnapshot} route
   * @param {string}                 paramName
   */
  getRouteData(route: ActivatedRouteSnapshot, paramName: string) {
    let currentRoute = route;
    while (currentRoute !== null) {
      let param = currentRoute.data[paramName];
      if (param) {
        return param;
      }
      currentRoute = currentRoute.parent;
    }
    throw new Error('Impossible to find route data named ' + paramName);
  }
}



// WEBPACK FOOTER //
// ./src/app/resolvers/default.resolver.ts